// Meta Pixel Code — código oficial de Meta, cargado desde la app.
export const META_PIXEL_ID = '1062042463475980';

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: FbqFunction;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return;

  const n = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args);
    } else {
      n.queue.push(args);
    }
  } as FbqFunction;

  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    value: 17,
    currency: 'USD',
    content_name: 'Mega Pack Maestro de Gemoterapia',
  });
}
